import { LangBadge } from "../shop/Flag";
import { useEffect, useState } from "react";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, imgUrl, eur, errMsg } from "../../lib/api";
import { DICT } from "../../lib/i18n";
import { ProductForm } from "./ProductForm";

const StockInput = ({ p, onSaved }) => {
  const [v, setV] = useState(p.stock);
  useEffect(() => { setV(p.stock); }, [p.stock]);
  const save = async () => {
    if (Number(v) === p.stock) return;
    try { await api.patch(`/admin/products/${p.id}/stock`, { stock: Number(v) }); toast.success("Bestand aktualisiert"); onSaved(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return <input type="number" min="0" value={v} onChange={(e) => setV(e.target.value)} onBlur={save} onKeyDown={(e) => e.key === "Enter" && e.target.blur()}
    data-testid={`stock-input-${p.slug}`} className={`w-20 rounded-lg border px-2 py-1 font-mono text-sm ${p.stock <= 2 ? "border-red-300 bg-red-50" : "border-[#120E1F]/10"}`} />;
};

export const ProductsPanel = () => {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(undefined);
  const load = () => api.get("/admin/products").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const del = async (p) => {
    if (!window.confirm(`"${p.name_de}" löschen?`)) return;
    await api.delete(`/admin/products/${p.id}`); toast.success("Gelöscht"); load();
  };

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <p className="text-sm text-[#707783]">{items.length} Produkte</p>
        <button className="btn-gold" onClick={() => setEditing(null)} data-testid="add-product-btn"><Plus className="h-4 w-4" />Produkt hinzufügen</button>
      </div>
      <div className="bg-white rounded-2xl border border-[#120E1F]/5 overflow-x-auto">
        <table className="w-full text-sm" data-testid="admin-products-table">
          <thead className="text-left text-[11px] uppercase tracking-[0.15em] text-[#707783] border-b"><tr>
            <th className="p-4">Produkt</th><th className="p-4">Sprache</th><th className="p-4">SKU</th><th className="p-4">Kategorie</th><th className="p-4">Preis</th><th className="p-4">Bestand</th><th className="p-4">Status</th><th className="p-4" /></tr></thead>
          <tbody>
            {items.map((p) => (
              <tr key={p.id} className="border-b last:border-0 hover:bg-[#F7F5FB]" data-testid={`admin-product-row-${p.slug}`}>
                <td className="p-4"><div className="flex items-center gap-3"><img src={imgUrl(p.images?.[0])} alt="" className="h-12 w-10 rounded object-cover bg-[#F7F5FB]" /><span className="font-medium">{p.name_de}</span></div></td>
                <td className="p-4"><LangBadge code={p.language} testid={`admin-product-lang-${p.sku}`} /></td>
                <td className="p-4 font-mono text-xs">{p.sku}</td>
                <td className="p-4 text-[#707783]">{DICT.de.cat[p.category]}</td>
                <td className="p-4 font-mono">{eur(p.price)}</td>
                <td className="p-4"><StockInput p={p} onSaved={load} /></td>
                <td className="p-4"><span className={`badge-pill ${p.active ? "bg-emerald-50 text-emerald-700" : "bg-gray-100 text-gray-500"}`}>{p.active ? "Sichtbar" : "Versteckt"}</span>{p.featured && <span className="badge-pill bg-[#F2C230]/15 text-[#6E3FB8] ml-1">★</span>}</td>
                <td className="p-4 whitespace-nowrap text-right">
                  <button onClick={() => setEditing(p)} className="p-2 hover:text-[#F2C230]" data-testid={`edit-product-${p.slug}`}><Pencil className="h-4 w-4" /></button>
                  <button onClick={() => del(p)} className="p-2 hover:text-red-600" data-testid={`delete-product-${p.slug}`}><Trash2 className="h-4 w-4" /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {editing !== undefined && <ProductForm key={editing?.id || "new"} product={editing} open onClose={() => setEditing(undefined)} onSaved={() => { setEditing(undefined); load(); }} />}
    </div>
  );
};
